export const CUSTOMER_REGIST = "CUSTOMER_REGIST";
export const SET_STORES = "SET_STORES";
export const SET_THERAPIST = "SET_THERAPIST";
export const SET_ACCOUNT_MENU = 'SET_ACCOUNT_MENU';
export const SET_ACCOUNT_COURSE = 'SET_ACCOUNT_COURSE';
export const SET_ACCOUNT_ASSIGN = 'SET_ACCOUNT_ASSIGN';
export const SET_ACCOUNT_OPTION = 'SET_ACCOUNT_OPTION';
export const SET_ACCOUNT_PAYMENT = 'SET_ACCOUNT_PAYMENT';
export const SET_ACCOUNT_EXTEND = 'SET_ACCOUNT_EXTEND';
export const SET_REFERRER = 'SET_REFERRER';
export const SET_USERS = 'SET_USERS';
export const SET_THERAPIST_SERVICE = 'SET_THERAPIST_SERVICE'
export const SET_THERAPIST_MANAGEMENT = 'SET_THERAPIST_MANAGEMENT';
export const SET_THERAPIST_SHIFT = 'SET_THERAPIST_SHIFT';
export const SET_THERAPIST_SHIFT_STORES = 'SET_THERAPIST_SHIFT_STORES'
export const SET_DISPLAY_DATE = 'SET_DISPLAY_DATE';
export const SET_THERAPIST_RESERVATOIN = 'SET_THERAPIST_RESERVATOIN';
export const SET_CONFIRMED_SHIFTS = 'SET_CONFIRMED_SHIFTS';
export const SET_INPUTTERS = 'SET_INPUTTERS';
export const SET_GENRES = 'SET_GENRES';
export const SET_SCHEDULES = 'SET_SCHEDULES';
export const SET_RESERVETABLESHIFTS = 'SET_RESERVETABLESHIFTS';
export const SET_DAILYREPORTDATA = 'SET_DAILYREPORTDATA';
export const SET_THERAPISTTALLYDATA = 'SET_THERAPISTTALLYDATA';
export const SET_TALLY_INPUT_DATA = 'SET_TALLY_INPUT_DATA';
export const SET_RESERVATION_FULL_DATA = 'SET_RESERVATION_FULL_DATA';
export const SET_CUSTOMERMGR_DATA = 'SET_CUSTOMERMGR_DATA';